import React from "react";

// Stylised SVG product placeholders, keyed by `kind`.
// To be swapped with real product photography later.

export const ProductVisual = ({ kind }) => {
    if (kind === "turbine") {
        return (
            <svg viewBox="0 0 320 220" className="w-full h-full">
                <defs>
                    <linearGradient id="tBody" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" stopColor="#ffffff" />
                        <stop offset="100%" stopColor="#bcc0c7" />
                    </linearGradient>
                </defs>
                <rect x="40" y="98" width="180" height="32" rx="8" fill="url(#tBody)" stroke="#9aa0aa" strokeWidth="0.4" />
                <rect x="170" y="98" width="6" height="32" fill="#00e5ff" />
                <path d="M220 102 L246 84 L260 90 L246 110 L260 118 L246 128 L260 138 L246 144 L220 126 Z" fill="url(#tBody)" stroke="#9aa0aa" strokeWidth="0.4" />
                <circle cx="262" cy="114" r="24" fill="url(#tBody)" stroke="#9aa0aa" strokeWidth="0.4" />
                <circle cx="262" cy="114" r="16" fill="#1c1c1e" />
                <circle cx="262" cy="114" r="3" fill="#00e5ff" />
            </svg>
        );
    }
    if (kind === "contra") {
        return (
            <svg viewBox="0 0 320 220" className="w-full h-full">
                <defs>
                    <linearGradient id="cBody" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" stopColor="#ffffff" />
                        <stop offset="100%" stopColor="#c2c6cc" />
                    </linearGradient>
                </defs>
                <rect x="34" y="100" width="160" height="28" rx="6" fill="url(#cBody)" stroke="#9aa0aa" strokeWidth="0.4" />
                <path d="M196 100 L228 60 L246 64 L222 110 L246 156 L228 160 L196 120 Z" fill="url(#cBody)" stroke="#9aa0aa" strokeWidth="0.4" />
                <rect x="232" y="48" width="14" height="22" fill="#1C1C1E" />
                <circle cx="60" cy="114" r="6" fill="#00e5ff" />
            </svg>
        );
    }
    if (kind === "endo") {
        return (
            <svg viewBox="0 0 320 220" className="w-full h-full">
                <defs>
                    <linearGradient id="eBody" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" stopColor="#1c1c1e" />
                        <stop offset="100%" stopColor="#2c2c2e" />
                    </linearGradient>
                </defs>
                <rect x="40" y="40" width="240" height="140" rx="18" fill="url(#eBody)" />
                <rect x="60" y="60" width="200" height="80" rx="6" fill="#0b0b0d" />
                <text x="160" y="100" textAnchor="middle" fontSize="12" fontFamily="JetBrains Mono" fill="#00e5ff">PROG · 0.6 N·cm</text>
                <text x="160" y="124" textAnchor="middle" fontSize="22" fontFamily="JetBrains Mono" fill="#fff">300 RPM</text>
                <rect x="70" y="156" width="40" height="14" rx="4" fill="#00e5ff" />
                <rect x="120" y="156" width="40" height="14" rx="4" fill="#d1d1d6" opacity="0.6" />
                <rect x="170" y="156" width="40" height="14" rx="4" fill="#d1d1d6" opacity="0.6" />
                <rect x="220" y="156" width="40" height="14" rx="4" fill="#d1d1d6" opacity="0.6" />
            </svg>
        );
    }
    if (kind === "implant") {
        return (
            <svg viewBox="0 0 320 220" className="w-full h-full">
                <defs>
                    <linearGradient id="iBody" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" stopColor="#ffffff" />
                        <stop offset="100%" stopColor="#c7cad0" />
                    </linearGradient>
                </defs>
                <rect x="20" y="30" width="280" height="160" rx="14" fill="#f2f3f5" stroke="#d1d1d6" />
                {[...Array(8)].map((_, i) => (
                    <g key={i} transform={`translate(${36 + i * 32}, 60)`}>
                        <rect x="0" y="0" width="22" height="100" rx="3" fill="url(#iBody)" stroke="#9aa0aa" strokeWidth="0.3" />
                        <polygon points={`0,100 11,${110 + i} 22,100`} fill="url(#iBody)" stroke="#9aa0aa" strokeWidth="0.3" />
                    </g>
                ))}
            </svg>
        );
    }
    if (kind === "torque") {
        return (
            <svg viewBox="0 0 320 220" className="w-full h-full">
                <defs>
                    <linearGradient id="wBody" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" stopColor="#ffffff" />
                        <stop offset="100%" stopColor="#c2c6cc" />
                    </linearGradient>
                </defs>
                <rect x="40" y="60" width="160" height="80" rx="14" fill="url(#wBody)" stroke="#9aa0aa" strokeWidth="0.4" />
                <rect x="50" y="74" width="120" height="40" rx="6" fill="#0b0b0d" />
                <text x="110" y="100" textAnchor="middle" fontSize="14" fontFamily="JetBrains Mono" fill="#00e5ff">35.0 N·cm</text>
                <rect x="200" y="80" width="80" height="40" rx="6" fill="url(#wBody)" stroke="#9aa0aa" strokeWidth="0.4" />
                <rect x="276" y="86" width="20" height="28" rx="4" fill="#1c1c1e" />
            </svg>
        );
    }
    if (kind === "burs") {
        return (
            <svg viewBox="0 0 320 220" className="w-full h-full">
                {[...Array(7)].map((_, i) => (
                    <g key={i} transform={`translate(${30 + i * 38}, 30)`}>
                        <rect x="8" y="20" width="6" height="110" fill="#c7cad0" />
                        <rect
                            x="0"
                            y={130 + (i % 3) * 2}
                            width="22"
                            height={20 + (i % 3) * 6}
                            rx={4 + (i % 3) * 2}
                            fill="#1c1c1e"
                        />
                        <circle cx="11" cy="18" r="6" fill="#00e5ff" opacity={i % 2 === 0 ? 0.8 : 0.3} />
                    </g>
                ))}
            </svg>
        );
    }
    return null;
};

export default ProductVisual;
